// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A1w7","content":"styles_content__1BuFg"};